var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71041 0.047849C11.0425 -0.199695 12.3324 0.535444 12.8167 1.73957L16.3932 1.07494C17.9069 0.79365 19.3662 1.78127 19.6506 3.28405L19.9272 4.74529C20.0154 5.21084 19.7057 5.65705 19.2388 5.74381L1.33065 9.07169C0.864153 9.15838 0.413057 8.85414 0.325 8.38896L0.0483968 6.92772C-0.236141 5.42457 0.763221 3.97946 2.27731 3.6981L5.74772 3.05319C5.75911 1.75701 6.6928 0.608612 8.02493 0.361062L9.71041 0.047849ZM9.94864 1.31161C10.5736 1.19549 11.1794 1.48196 11.4956 1.98507L7.06829 2.80779C7.17861 2.2254 7.63828 1.74095 8.26316 1.62483L9.94864 1.31161ZM16.6314 2.33871C17.4448 2.18755 18.226 2.71854 18.378 3.52153L18.5744 4.55925L1.51768 7.7289L1.32106 6.69024C1.16913 5.88762 1.70248 5.11296 2.51554 4.96186L16.6314 2.33871Z",
    fill: "#E7332F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46702 13.9624C6.42951 13.6093 6.11081 13.3533 5.7552 13.3905C5.39958 13.4277 5.1417 13.7442 5.17921 14.0972L6.251 24.1857C6.28851 24.5387 6.60721 24.7948 6.96283 24.7575C7.31844 24.7203 7.57632 24.4039 7.53881 24.0508L6.46702 13.9624Z",
    fill: "#E7332F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.738 14.0972C15.7755 13.7442 15.5176 13.4277 15.162 13.3905C14.8064 13.3533 14.4877 13.6093 14.4502 13.9624L13.3784 24.0508C13.3409 24.4039 13.5988 24.7203 13.9544 24.7575C14.31 24.7948 14.6287 24.5387 14.6662 24.1857L15.738 14.0972Z",
    fill: "#E7332F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0257 14.0298C11.0257 13.6748 10.7358 13.3869 10.3782 13.3869C10.0206 13.3869 9.73075 13.6748 9.73075 14.0298V24.1182C9.73075 24.4733 10.0206 24.7611 10.3782 24.7611C10.7358 24.7611 11.0257 24.4733 11.0257 24.1182V14.0298Z",
    fill: "#E7332F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83109 10.6348C1.31594 10.6348 0.913703 11.0813 0.975391 11.5918L2.65566 26.498C2.75933 27.356 3.49335 28 4.36272 28H16.5075C17.3724 28 18.104 27.3625 18.2131 26.5098L19.993 11.5977C20.0586 11.0852 19.6556 10.6348 19.138 10.6348H1.83109ZM3.94139 26.3449L2.31933 11.9205H18.6463L16.9285 26.3477C16.9018 26.5562 16.7223 26.7143 16.5075 26.7143H4.36272C4.14677 26.7143 3.96673 26.5546 3.94139 26.3449Z",
    fill: "#E7332F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.727f769741e1746eb4dd414f0699cd7a.svg";
export { ForwardRef as ReactComponent };